import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ text, time }: IProps) => {
    const getWord = useDictionary();

    return (
        <Box className="send-again">
            <Typography className="send-again__text">
                {time ? getWord(text) : ''}
            </Typography>
            <Typography className="send-again__timer" variant="h5">
                {time ? `${time}` : ''}
            </Typography>
        </Box>
    );
};

const SendAgainComponent = React.memo(Component);

export default SendAgainComponent;
